<form class="flex flex-col gap-4" [formGroup]="timingForm">
  <div class="flex flex-row gap-4">
    <mat-button-toggle-group
      [value]="isImmediate()"
      [hideSingleSelectionIndicator]="true"
      (change)="setImmediately($event.value)"
    >
      <mat-button-toggle
        matTooltip="This will run relative to when the appointment is scheduled for."
        [value]="false"
      >
        Based on a schedule
      </mat-button-toggle>
      <mat-button-toggle
        matTooltip="This will run when the appointment is created/booked or as soon as this automation is added to an existing appointment."
        [value]="true"
      >
        Immediately
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  @if (!isImmediate()) {
    <div class="flex flex-row gap-4">
      <mat-form-field class="w-32" subscriptSizing="dynamic">
        <mat-label>Amount</mat-label>
        <input
          matInput
          formControlName="amount"
          type="number"
          min="1"
          required
        />
      </mat-form-field>

      <mat-form-field class="w-32" subscriptSizing="dynamic">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="unit" required>
          @for (unit of timingUnits; track unit) {
            <mat-option [value]="unit"> {{ unit }} </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-72" subscriptSizing="dynamic">
        <mat-label>Direction</mat-label>
        <mat-select formControlName="direction" required>
          @for (direction of timingDirections(); track direction.value) {
            <mat-option [value]="direction.value">
              {{ direction.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (showTriggerTime()) {
      <div class="flex flex-row items-center gap-4">
        <mat-form-field
          class="w-80"
          subscriptSizing="dynamic"
          matTooltip="Deselect the days that you don't want this automation to run on. An automation due to run on a day that is not selected will be run on the first available selected day."
        >
          <mat-label>On these days</mat-label>
          <mat-select formControlName="daysOfWeek" multiple>
            @for (day of daysOfWeek; track day) {
              <mat-option [value]="day">{{ day | titlecase }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="text-xl">&commat;</div>
        <pt-iso-time-selector
          class="w-48"
          label="Time of day"
          formControlName="time"
        />
      </div>

      @if (showCountOnlySelectedDays$ | async) {
        <mat-checkbox formControlName="countOnlySelectedDays">
          Count only selected days
          <mat-icon
            class="icon-xs opacity-50"
            matTooltip="When checked, only selected days are counted when calculating timing, resulting in more evenly distributed messages."
          >
            info
          </mat-icon>
        </mat-checkbox>
      }

      <pr-automation-timing-examples
        [automationTiming]="timingForm.valueChanges | async"
      />
    }
  }
</form>
